import { render, staticRenderFns } from "./SkeletonBanner.vue?vue&type=template&id=ba791a3e&"
import script from "./SkeletonBanner.vue?vue&type=script&lang=js&"
export * from "./SkeletonBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports